// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:06
import { TrafficFlowResults_abstract } from './../abstract/SagaBase/TrafficFlowResults_abstract';
export class TrafficFlowResults extends TrafficFlowResults_abstract {}
